var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocumentsPressed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "25px",
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_documents copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 17.1849017 0 17.1849017 21.2765273 0 21.2765273"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 15.5488433 0 15.5488433 15.2758729 0 15.2758729"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_documents-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70728168,2.48957118 C1.70728168,2.05819082 2.05813391,1.70705404 2.48951427,1.70705404 L10.0679794,1.70705404 L10.0679794,4.59809919 C10.0679794,5.97077654 11.1848448,7.08735737 12.5575221,7.08735737 L15.4775916,7.08735737 L15.4775916,18.7867001 C15.4775916,19.2180804 15.1264548,19.5692172 14.695359,19.5692172 L2.48951427,19.5692172 C2.05813391,19.5692172 1.70728168,19.2180804 1.70728168,18.7867001 L1.70728168,2.48957118 Z M14.2625558,5.38004724 L12.5575221,5.38004724 C12.1261418,5.38004724 11.7752895,5.02947955 11.7752895,4.59809919 L11.7752895,2.9064394 L14.2625558,5.38004724 Z M2.48951427,21.2765273 L14.695359,21.2765273 C16.0680363,21.2765273 17.1849017,20.159662 17.1849017,18.7867001 L17.1849017,6.85459409 C17.1849017,6.23484051 16.9325043,5.62789176 16.492872,5.19053581 L11.9602481,0.682098853 C11.5174857,0.242181942 10.9298865,-0.00025609652 10.3055801,-0.00025609652 L2.48951427,-0.00025609652 C1.11683692,-0.00025609652 -2.84551688e-05,1.11689383 -2.84551688e-05,2.48957118 L-2.84551688e-05,18.7867001 C-2.84551688e-05,20.159662 1.11683692,21.2765273 2.48951427,21.2765273 L2.48951427,21.2765273 Z",
    id: "Fill-1",
    fill: "#172B4E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(4.451157, 8.817119)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3719091,15.2758729 L0.853655066,15.2758729 C0.382152918,15.2758729 0,14.8937199 0,14.4222178 C0,13.9507156 0.382152918,13.5685627 0.853655066,13.5685627 L10.3719091,13.5685627 C12.2852346,13.5685627 13.8417324,12.0117804 13.8417324,10.0987394 L13.8417324,0.853655066 C13.8417324,0.382152918 14.2238853,0 14.6953874,0 C15.1668896,0 15.5490425,0.382152918 15.5490425,0.853655066 L15.5490425,10.0987394 C15.5490425,12.953362 13.2265316,15.2758729 10.3719091,15.2758729",
    id: "Fill-4",
    fill: "#172B4E",
    mask: "url(#mask-4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentsPressed);
export default __webpack_public_path__ + "static/media/icon_documents_pressed..3aaf75ab4d94117a44f004c00926f46c.svg";
export { ForwardRef as ReactComponent };